module.exports = __webpack_public_path__ + "static/team-jesse-5cb7a5fc3be5e26786006e361d1405e7.jpg";